import React from "react";
import { connect } from 'react-redux';
import _ from 'lodash';
import { format, addDays, startOfWeek, parse, getDay } from 'date-fns'
import { Actions as ACTIONS } from '../../../store/actions/leaveActions';
import Tooltip from "@/tooltip";

const types = {
    'HP': 'Half Pay',
    'FP': 'Full Pay',
    'SSP': 'Statutory Sick Pay',
    'WD': 'Waiting Day',
    'US': 'Unpaid',
    'UP': 'Unpaid',
    'SB': 'Sick Benefit',
    'PH': 'Public Holiday',
    'SMP': 'Statutory Maternity Pay',
    'ShPP': 'Shared Parental Pay',
    'SAP': 'Statutory Adoption Pay',
    'SPP': 'Statutory Paternity Pay'
}

const BenefitType = ({
    jurisdiction,
    modalLeave,
    dateToUseString,
    sickType,
    editedSickType,
    updateBreakdown,
    hours,
    holidays,
    addPhToLeave,
    blockType,
    updateField,
    weekBenefit,
    isPaid,
    type,
    sickChainDate
}) => {
    const { date, dateTo } = modalLeave
    const isHoliday = holidays?.includes(dateToUseString) && !addPhToLeave
    sickType = (sickType != 'US' && ['6020', '6022'].includes(String(type)) && isHoliday) ? 'PH' : sickType

    if (!sickType && !weekBenefit) return null

    if (date === dateTo) return (
        <div className="col-xs-6 pl-0">
            <label>{isHoliday ? 'Day' : 'Sick Type'}</label>
            <div
                className={`leaveDayTip singleDayTip ${editedSickType ? editedSickType : sickType}`}
                style={{ cursor: 'default', userSelect: 'none' }}
            // style={{ cursor: jurisdiction == 'MT' && !["FP", "SB"].includes(sickType) && !isPaid ? 'pointer' : 'default', userSelect: 'none' }}
            // onClick={() => {
            //     if (isPaid) return
            //     if (jurisdiction != 'MT') return
            //     if (["FP", "SB"].includes(sickType)) return

            //     let newBenefit

            //     switch (editedSickType) {
            //         case "US": newBenefit = 'HP'; break
            //         case "HP": newBenefit = 'FP'; break
            //         case "FP": newBenefit = sickType === 'HP' ? 'HP' : 'US'; break
            //         default: newBenefit = sickType === 'HP' ? 'FP' : 'HP'; break
            //     }
            //     updateField(newBenefit)
            // }}
            >{types[editedSickType ? editedSickType : sickType]}</div>
            {sickChainDate &&
                <div style={{ fontSize: "11px" }}>
                    <span>
                        Linked to Sick on: <strong>{format(parse(sickChainDate, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy')}</strong>
                    </span>
                </div>
            }
        </div>
    )

    if (!hours && !sickType && (blockType == 'week' ? !weekBenefit : true)) return null

    const status = blockType == 'week' ? weekBenefit : (editedSickType ? editedSickType : sickType)
    // console.debug(status)
    const statusName = types[status]

    return (
        <p
            className={`leaveDayTip multiDayTip ${status}`}
            // style={{ cursor: jurisdiction == 'MT' && !["FP", "SB"].includes(sickType) && !isPaid ? 'pointer' : 'default', userSelect: 'none' }}
            style={{ cursor: 'default', userSelect: 'none', right: blockType == 'week' ? '-1.5rem' : undefined }}
        // onClick={() => {
        //     if (isPaid) return
        //     if (jurisdiction != 'MT') return
        //     if (["FP", "SB"].includes(sickType)) return

        //     let newBenefit

        //     switch (editedSickType) {
        //         case "US": newBenefit = 'HP'; break
        //         case "HP": newBenefit = 'FP'; break
        //         case "FP": newBenefit = sickType === 'HP' ? 'HP' : 'US'; break
        //         default: newBenefit = sickType === 'HP' ? 'FP' : 'HP'; break
        //     }
        //     updateBreakdown({ dateToUseString, hours, editedSickType: newBenefit })
        // }}
        >
            <Tooltip content={statusName}>
                {status}
            </Tooltip>
        </p>
    )

}

const mapStateToProps = (state, ownProps) => {
    const day = ownProps.day || 0
    const weekNo = ownProps.weekNo || 0
    const weekStartsOn = state.company?.settings?.jurisdiction == "UK" ? 0 : 1
    const { hoursBreakdown, weeklyBreakdown, sickType, date, isPaid, sickChainDate, type } = state.leave?.modalLeave
    const fromDate = date ? parse(date, 'yyyy-MM-dd', new Date()) : new Date()
    const firstDay = startOfWeek(fromDate, { weekStartsOn })
    const dateToUse = addDays(firstDay, day + weekNo * 7)
    const dateToUseString = format(dateToUse, "yyyy-MM-dd")

    const effectiveObject = hoursBreakdown?.[dateToUseString]
    const weekBenefit = weeklyBreakdown?.[weekNo]
    // console.debug(weekBenefit)

    const displayedSickType = effectiveObject?.sickType == 'FP' && effectiveObject?.benefit ? effectiveObject?.benefit : effectiveObject?.sickType || sickType

    return {
        jurisdiction: state.company?.settings?.jurisdiction,
        weekStartsOn,
        sickType: displayedSickType,
        hours: effectiveObject?.hours,
        weekBenefit,
        sickChainDate,
        isPaid: effectiveObject?.isPaid || isPaid,
        editedSickType: effectiveObject?.editedSickType || state.leave?.modalLeave?.editedSickType,
        dateToUseString,
        holidays: state.leave?.modalStatus?.holidays,
        addPhToLeave: !!state.leave?.leaveSettings?.addPhToLeave,
        modalLeave: state.leave.modalLeave || {},
        type,
        modalStatus: state.leave?.modalStatus?.status || {},
        days: state.leave?.days
    }
}

const mapDispatchToProps = dispatch => ({
    updateBreakdown: ({ dateToUseString, hours, editedSickType }) => {
        dispatch(ACTIONS.updateBreakdown({ dateToUseString, hours, editedSickType, edited: true }))
        dispatch(ACTIONS.mapBreakdown())
    },
    updateField: (newValue) => dispatch(ACTIONS.modalUpdateField('editedSickType', newValue)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BenefitType)
